module.exports = __webpack_public_path__ + "static/media/C022.e6101e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C022.jpg
// module id = 305
// module chunks = 0